import { defineMessages } from 'utils/intl';

export default defineMessages({
  header: 'Brak dostępnych produktów {productName}',
  description:
    'Jeżeli chcesz sprawdzić, czy wariant którego szukasz znajduje się na liście produktów niedostępnych, odznacz przycisk “Pokaż dostępne” lub {clickHere}.',
  clickHere: 'kliknij tutaj',
});
